import React, {useEffect} from "react";
import styled from 'styled-components';
import {Link} from "react-router-dom";
import {useInView} from "react-intersection-observer";
import anime from "animejs";

const LinkWrapper = styled.span`
  opacity: 0;
`;

const StyledSvg = styled.svg`
  transition: all .2s ease-out; 
  width: ${props => props.width ? props.width : '1rem'};
  fill: currentColor;
  transform-origin: 50% 50%;
  ${props => props.directionReversed && `
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  `}
`;

const StyledP = styled.p`
  display: inline-block;
  margin: 0;
  margin-${props => props.directionReversed ? 'left': 'right'}: 0.5rem;
`;

const StyledLink = styled(({
  textColor,
  directionReversed,
  ...rest
}) => <Link {...rest}/>)`
  color: ${props => props.textColor};
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  display: inline-block;
  transition: all .2s ease-out; 

  ::after {
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    padding-top: 0.1rem;
    background: #635BFF;
    position: absolute;
    ${props => props.directionReversed ? 'right': 'left'}: -2px;
    bottom: 0;
    transform: ${props => props.directionReversed ? 'translate3d(100%, 0, 0);': 'translate3d(-100%, 0, 0);'} 
    transition: transform .2s ease-out;
  }

  :hover {
    color: #635BFF;

    ::after {
      left: 0;
      transform: translate3d(0, 0, 0);
    }
  }
`;

const StyledArrowComponent = ({arrowWidth, directionReversed}) => (
    <StyledSvg
        width={arrowWidth}
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        enableBackground="new 0 0 492.004 492.004"
        version="1.1"
        viewBox="0 0 492.004 492.004"
        directionReversed={directionReversed}
        xmlSpace="preserve">
    <path d="M484.14 226.886L306.46 49.202c-5.072-5.072-11.832-7.856-19.04-7.856-7.216 0-13.972 2.788-19.044 7.856l-16.132 16.136c-5.068 5.064-7.86 11.828-7.86 19.04 0 7.208 2.792 14.2 7.86 19.264L355.9 207.526H26.58C11.732 207.526 0 219.15 0 234.002v22.812c0 14.852 11.732 27.648 26.58 27.648h330.496L252.248 388.926c-5.068 5.072-7.86 11.652-7.86 18.864 0 7.204 2.792 13.88 7.86 18.948l16.132 16.084c5.072 5.072 11.828 7.836 19.044 7.836 7.208 0 13.968-2.8 19.04-7.872l177.68-177.68c5.084-5.088 7.88-11.88 7.86-19.1.016-7.244-2.776-14.04-7.864-19.12z"/>
</StyledSvg>);

const ViewMoreLink = ({
  arrowWidth,
  buttonText,
  to,
  directionReversed,
  textColor = '#292C31',
}) => {
  const [ref, inView, entry] = useInView({triggerOnce: true});

  // link animation
  useEffect(() => {
    if (inView) {
      anime({
        targets: entry && entry.target,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1000,
        delay: 500,
      });
    }

    return () => {
      anime({
        targets: entry && entry.target,
        opacity: [1, 0],
        easing: "easeOutExpo",
        duration: 100,
      });
    };
  }, [inView, entry]);

  return <LinkWrapper ref={ref}>
    <StyledLink directionReversed={directionReversed} to={to} textColor={textColor}>
      {directionReversed &&
        <StyledArrowComponent
          arrowWidth={arrowWidth}
          directionReversed={directionReversed} />
      }
      <StyledP directionReversed={directionReversed}>{buttonText}</StyledP>
      {!directionReversed &&
      <StyledArrowComponent
          arrowWidth={arrowWidth}
          directionReversed={directionReversed} />
      }
    </StyledLink>
  </LinkWrapper>;
}

export default ViewMoreLink;
